import React, { FormEvent, useEffect, useState } from "react";

import Pagination from "../../components/common/Pagination";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { createNotice, deleteNotice, fetchNotices, updateNotice } from "../../store/slices/noticesSlice";
import { formatDate } from "../../utils/admin";

const NoticesPage = () => {
  const dispatch = useAppDispatch();
  const { list, totalCount, page, pageSize, loadingList, listError } = useAppSelector((state) => state.notices);

  const [pageState, setPageState] = useState(1);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [editingId, setEditingId] = useState<number | null>(null);

  useEffect(() => {
    dispatch(fetchNotices({ page: pageState, page_size: 20 }));
  }, [dispatch, pageState]);

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!title.trim() || !content.trim()) {
      return;
    }

    try {
      if (editingId) {
        await dispatch(updateNotice({ noticeId: editingId, payload: { title, content } })).unwrap();
        window.alert("공지사항이 성공적으로 수정되었습니다.");
      } else {
        await dispatch(createNotice({ title, content })).unwrap();
        window.alert("공지사항이 성공적으로 등록되었습니다.");
      }

      setTitle("");
      setContent("");
      setEditingId(null);
      dispatch(fetchNotices({ page: pageState, page_size: 20 }));
    } catch (error) {
      window.alert(error as string || "저장에 실패했습니다.");
    }
  };

  return (
    <section className="admin-page">
      <h2 className="section-title">공지사항</h2>

      <form className="editor-card" onSubmit={onSubmit}>
        <input placeholder="제목" value={title} onChange={(event) => setTitle(event.target.value)} />
        <textarea placeholder="내용" value={content} onChange={(event) => setContent(event.target.value)} />
        <button className="primary-btn" type="submit">
          {editingId ? "공지 수정" : "공지 등록"}
        </button>
      </form>

      <div className="table-shell">
        <table className="admin-table">
          <thead>
            <tr>
              <th>제목</th>
              <th>게시일</th>
              <th>수정일</th>
              <th>관리</th>
            </tr>
          </thead>
          <tbody>
            {list.map((notice) => (
              <tr key={notice.notice_id}>
                <td>{notice.title}</td>
                <td>{formatDate(notice.published_at)}</td>
                <td>{formatDate(notice.updated_at)}</td>
                <td>
                  <div className="table-actions">
                    <button
                      className="table-action-btn"
                      type="button"
                      onClick={() => {
                        setEditingId(notice.notice_id);
                        setTitle(notice.title);
                        setContent(notice.content);
                      }}
                    >
                      수정
                    </button>
                    <button
                      className="table-action-btn danger"
                      type="button"
                      onClick={async () => {
                        if (window.confirm("정말로 이 공지사항을 삭제하시겠습니까?")) {
                          try {
                            await dispatch(deleteNotice(notice.notice_id)).unwrap();
                            window.alert("공지사항이 삭제되었습니다.");
                            dispatch(fetchNotices({ page: pageState, page_size: 20 }));
                          } catch (error) {
                            window.alert(error as string || "삭제에 실패했습니다.");
                          }
                        }
                      }}
                    >
                      삭제
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {!loadingList && list.length === 0 && (
              <tr>
                <td className="empty-row" colSpan={4}>
                  등록된 공지사항이 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {loadingList && <p className="loading-text">공지사항 목록을 불러오는 중입니다...</p>}
      {listError && <p className="error-text">{listError}</p>}
      <Pagination page={page || pageState} pageSize={pageSize || 20} totalCount={totalCount} onPageChange={setPageState} />
    </section>
  );
};

export default NoticesPage;
